import {
  addNewValueToAttribute,
  fetchAttributeValues
} from "@/modules/offers/api/productModeration"
import type { ManualAttributeValueRequest } from "@/modules/offers/types/createOffer"
import type { ProductModerationAttributeValue } from "@/modules/offers/types/offers"
import type {
  AttributeValuesQuery,
  CreateAttributeValuePayload
} from "@/modules/offers/types/productModeration"

import { getAttributeValueLabel } from "./attributeLabels"

export const getOrCreateAttributeValue = async ({
  attribute,
  attrValue
}: ManualAttributeValueRequest): Promise<ProductModerationAttributeValue[]> => {
  if (!attrValue) return []

  const queryParams: AttributeValuesQuery & { code: string } = {
    code: attribute.code,
    value_str_contains: attrValue.value.toString()
  }

  if (attribute.value_type === "NUMERIC") {
    queryParams.unit = attrValue.unit?.oid || null
  }

  const { data } = await fetchAttributeValues({ queryParams })
  const existingValue = data.results.find(
    (value) =>
      (value.value === attrValue.value || getAttributeValueLabel(value) === attrValue.value) &&
      (value.unit?.oid || null) === (queryParams.unit || null)
  )

  if (existingValue) return [existingValue]

  const payload: CreateAttributeValuePayload =
    attribute.value_type === "STRING"
      ? { value_mlang: { uk: attrValue.value } }
      : { value: attrValue.value, unit: attrValue.unit?.oid || null }
  const { data: createdValue } = await addNewValueToAttribute({
    code: attribute.code,
    payload
  })
  return [createdValue]
}
